import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useNavigation } from "@react-navigation/native";
import { Box } from "arkh";
import React from "react";

import { IntegrationHeader } from "./IntegrationHeader";
import { IntegrationInput } from "./IntegrationInput";

export function IntegrationActivateScreen(props: {
  header: React.ReactNode;
  activation: React.ReactNode;
  onActivate: () => void;
  isValid: boolean;
  isActivating: boolean;
}) {
  const intl_tokens = useIntlTokens();
  const navigation = useNavigation();

  useNavigationHeader({
    type: "CREATE",
    createButtonLabel: intl_tokens.Activate,
    onCancel: () => navigation.goBack(),
    onSave: () => props.onActivate(),
    saveLoading: props.isActivating,
    disabled: !props.isValid,
  });

  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      {props.header}
      <Box space="medium">{props.activation}</Box>
    </Box>
  );
}

IntegrationActivateScreen.Header = IntegrationHeader;
IntegrationActivateScreen.Input = IntegrationInput;
